import {FlagPlaceholder, StyledDropdownWrapper, StyledImg} from './styled';
import {useFlagImgSrc} from './useFlagImgSrc';
import Text from '@planday-corp/ui/text/Text';
import React from 'react';
import {CombinedCountryData} from '~/Signup/types';

interface Props {
  value: string | undefined;
  onClick: () => void;
  countriesPhoneData: CombinedCountryData[];
}

export default function CountryFlagSummary({
  value,
  onClick,
  countriesPhoneData,
}: Props) {
  const countryData = countriesPhoneData.find(
    country => country.countryCode === value
  );
  const {prefixNumber, countryName, countryCode} = countryData || {};

  const flagImgSrc = useFlagImgSrc(countryCode);

  return (
    <StyledDropdownWrapper onClick={onClick}>
      {flagImgSrc ? (
        <StyledImg src={flagImgSrc} alt={`flag-${countryName}`} />
      ) : (
        <FlagPlaceholder />
      )}
      {countryCode && <Text value={prefixNumber} color="grey60" />}
    </StyledDropdownWrapper>
  );
}
